import script from "./SyncedGroupIcon.vue?vue&type=script&lang=js"
export * from "./SyncedGroupIcon.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__